import Grid from './grid';
import Item from './item';

Grid.Item = Item;

export default Grid;
